import styled from 'styled-components';

import { getNonStickyTop } from '@marriott/mi-store-utils';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

type StickyProps = {
  $isSticky: boolean;
  $top: number;
  $isNorthStar?: boolean;
  $hasGlobalNav?: boolean;
  $offset: number;
};

export const StyledStickyComponentWrapper = styled.div<StickyProps>`
  width: ${({ $isSticky }) => ($isSticky ? '100vw' : '100%')};
  max-width: 100%;
  position: ${({ $isSticky }) => ($isSticky ? 'fixed' : 'relative')};
  ${({ $isSticky }) => ($isSticky ? 'left: 0; right: 0; z-index: 50;' : '')}
  ${({ $isSticky, $top }) => ($isSticky && $top !== 0 ? 'transition: top 0.4s ease 0s;' : '')}
  top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
    $isSticky
      ? toRem($top)
      : `calc(${toRem(getNonStickyTop('xs', $isNorthStar, $hasGlobalNav))} + var(--tab-title-wrap-offset, 0px))`};
  @media ${baseVariables.mediaQuery.sm} {
    top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
      $isSticky ? toRem($top) : toRem(getNonStickyTop('sm', $isNorthStar, $hasGlobalNav))};
  }
  @media ${baseVariables.mediaQuery.md} {
    top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
      $isSticky ? toRem($top) : toRem(getNonStickyTop('md', $isNorthStar, $hasGlobalNav))};
  }
  @media ${baseVariables.mediaQuery.lg} {
    top: ${({ $isSticky, $top, $isNorthStar, $hasGlobalNav }) =>
      $isSticky ? toRem($top) : toRem(getNonStickyTop('lg', $isNorthStar, $hasGlobalNav))};
  }

  .search-form-position {
    width: 100vw !important;
  }
`;
